module.exports = __webpack_public_path__ + "static/media/le1Transparent.f9d14462.png";